<template>
    <div>
        <h2>Do you agree or disagree with the following statements?</h2>

        <ul class="likert-statement">
            <li class="statement">I think of the family business as a legacy to leave future generations
                <ul class='likert'>
                    <li>
                        <input v-model="likertl151" type="radio" id="l1a1" name="likertl151" value="agree" @click="sc('likertl151', 'agree')">
                        <label for="l1a1">Agree</label>
                    </li>
                    <li>
                        <input v-model="likertl151" type="radio" id="l1a2" name="likertl151" value="somewhat_agree" @click="sc('likertl151', 'somewhat_agree')">
                        <label for="l1a2">Somewhat agree</label>
                    </li>
                    <li>
                        <input v-model="likertl151" type="radio" id="l1a3" name="likertl151" value="somewhat_disagree" @click="sc('likertl151', 'somewhat_disagree')">
                        <label for="l1a3">Somewhat disagree</label>
                    </li>
                    <li>
                        <input v-model="likertl151" type="radio" id="l1a4" name="likertl151" value="disagree" @click="sc('likertl151', 'disagree')">
                        <label for="l1a4">Disagree</label>
                    </li>
                </ul>
            </li>
            <li class="statement">I expect that future generations will want to explore other opportunities and career aspirations.
                <ul class='likert'>
                    <li>
                        <input v-model="likertl152" type="radio" id="l2a1" name="likertl152" value="agree" @click="sc('likertl152', 'agree')">
                        <label for="l2a1">Agree</label>
                    </li>
                    <li>
                        <input v-model="likertl152" type="radio" id="l2a2" name="likertl152" value="somewhat_agree" @click="sc('likertl152', 'somewhat_agree')">
                        <label for="l2a2">Somewhat agree</label>
                    </li>
                    <li>
                        <input v-model="likertl152" type="radio" id="l2a3" name="likertl152" value="somewhat_disagree" @click="sc('likertl152', 'somewhat_disagree')">
                        <label for="l2a3">Somewhat disagree</label>
                    </li>
                    <li>
                        <input v-model="likertl152" type="radio" id="l2a4" name="likertl152" value="disagree" @click="sc('likertl152', 'disagree')">
                        <label for="l2a4">Disagree</label>
                    </li>
                </ul>
            </li>
            <li class="statement">I expect that future generations will continue to be responsible for the day-to-day operations.
                <ul class='likert'>
                    <li>
                        <input v-model="likertl153" type="radio" id="l3a1" name="likertl153" value="agree" @click="sc('likertl153', 'agree')">
                        <label for="l3a1">Agree</label>
                    </li>
                    <li>
                        <input v-model="likertl153" type="radio" id="l3a2" name="likertl153" value="somewhat_agree" @click="sc('likertl153', 'somewhat_agree')">
                        <label for="l3a2">Somewhat agree</label>
                    </li>
                    <li>
                        <input v-model="likertl153" type="radio" id="l3a3" name="likertl153" value="somewhat_disagree" @click="sc('likertl153', 'somewhat_disagree')">
                        <label for="l3a3">Somewhat disagree</label>
                    </li>
                    <li>
                        <input v-model="likertl153" type="radio" id="l3a4" name="likertl153" value="disagree" @click="sc('likertl153', 'disagree')">
                        <label for="l3a4">Disagree</label>
                    </li>
                </ul>
            </li>
            <li class="statement">We can find a rewarding place for any family member who wants to work in the family business
                <ul class='likert'>
                    <li>
                        <input v-model="likertl154" type="radio" id="l4a1" name="likertl154" value="agree" @click="sc('likertl154', 'agree')">
                        <label for="l4a1">Agree</label>
                    </li>
                    <li>
                        <input v-model="likertl154" type="radio" id="l4a2" name="likertl154" value="somewhat_agree" @click="sc('likertl154', 'somewhat_agree')">
                        <label for="l4a2">Somewhat agree</label>
                    </li>
                    <li>
                        <input v-model="likertl154" type="radio" id="l4a3" name="likertl154" value="somewhat_disagree" @click="sc('likertl154', 'somewhat_disagree')">
                        <label for="l4a3">Somewhat disagree</label>
                    </li>
                    <li>
                        <input v-model="likertl154" type="radio" id="l4a4" name="likertl154" value="disagree" @click="sc('likertl154', 'disagree')">
                        <label for="l4a4">Disagree</label>
                    </li>
                </ul>
            </li>

        </ul>
    </div>
</template>


<script>

function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default {
    name: "quiz2",
    components: {

    },
    data() {
        return {
            q21: (getCookie("q21") ? getCookie("q21") : 0),
            q11: (getCookie("q11") ? getCookie("q11") : 0),
            likertl151: (getCookie("likertl151") ? getCookie("likertl151") : 0),
            likertl152: (getCookie("likertl152") ? getCookie("likertl152") : 0),
            likertl153: (getCookie("likertl153") ? getCookie("likertl153") : 0),
            likertl154: (getCookie("likertl154") ? getCookie("likertl154") : 0),

            likertl111: (getCookie("likertl111") ? getCookie("likertl111") : 0),
            likertl112: (getCookie("likertl112") ? getCookie("likertl112") : 0),
            likertl113: (getCookie("likertl113") ? getCookie("likertl113") : 0),
        };
    },
 
    methods: {
        sc(c,v) {
            if (c == "q21") { this.q21 = v; }
            if (c == "q11") { this.q11 = v; }
            if (c == "likertl151") { this.likertl151 = v; }
            if (c == "likertl152") { this.likertl152 = v; }
            if (c == "likertl153") { this.likertl153 = v; }
            if (c == "likertl154") { this.likertl154 = v; }

            if (c == "likertl111") { this.likertl111 = v; }
            if (c == "likertl112") { this.likertl112 = v; }
            if (c == "likertl113") { this.likertl113 = v; }
            
            
            setCookie(c,v);
        },
    }
    
}

</script>
